import { Alignments } from 'rich-text-lib/constants/alignments';
export const STYLE_OPTIONS = {
  [Alignments.LEFT]: {
    float: 'left',
    'margin-left': '0px',
    'margin-right': '10px',
    display: 'block'
  },
  [Alignments.CENTER]: {
    float: null,
    'margin-left': 'auto',
    'margin-right': 'auto',
    display: 'block'
  },
  [Alignments.RIGHT]: {
    float: 'right',
    'margin-left': '10px',
    'margin-right': '0px',
    display: 'block'
  },
  [Alignments.NONE]: {
    float: null,
    'margin-left': '0px',
    'margin-right': '0px',
    display: 'inline-block'
  }
};
export const MEDIA_SETTINGS = 'hsMedia';
export const hsmediaConfig = {
  DISABLE_ALIGNMENT: 'mediaDisableAlignment',
  DISABLE_SPACING: 'mediaDisableSpacing',
  DEFAULT_STYLES: 'mediaDefaultStyles',
  MAX_DIMENSION_WIDTH: 'mediaMaxDimensionWidth'
};

// Represents standard 16:9 aspect ratio
export const DefaultIframeDimensions = {
  WIDTH: 560,
  HEIGHT: 315
};

// Ideally we deafult to 560px, but that is too large for twitter & instagram
// embed codes (they have max-width: 550|540px respectively)
export const DEFAULT_EMBED_WIDTH = 540;
export const IFRAME_MIN_WIDTH = 256;

// Classnames used for old boilerplate responsive css
// https://git.hubteam.com/HubSpot/DesignAssets/issues/104
export const RESPONSIVE_EMBED_CLASS = 'hs-responsive-embed';
export const RESPONSIVE_EMBED_IFRAME_CLASS = 'hs-responsive-embed-iframe';

// New responsive embed classnames
export const RESPONSIVE_EMBED_WRAPPER_CLASS = 'hs-responsive-embed-wrapper';
export const RESPONSIVE_EMBED_INNER_WRAPPER_CLASS = 'hs-responsive-embed-inner-wrapper';
export const RESPONSIVE_EMBED_FULL_WIDTH_CLASS = 'hs-fullwidth-embed';

// Newest (hopefully final) embed classnames
export const HS_EMBED_WRAPPER_CLASS = 'hs-embed-wrapper';
export const HS_EMBED_INNER_WRAPPER_CLASS = 'hs-embed-inner-wrapper'; // used only in the placeholder
export const HS_EMBED_CONTENT_WRAPPER_CLASS = 'hs-embed-content-wrapper';